import { KioskStringsDto } from '@groundfloor-platform/mgmt-service-g-sdk';

/**
 * Flat map of editable on-screen text values, keyed by their `KioskStringsDto` property names.
 * Fields are blank unless the kiosk has a customised value; blank fields are omitted on save so the
 * kiosk falls back to its configuration schema defaults.
 */
export type KioskStringValues = { [K in keyof KioskStringsDto]-?: string };

export interface KioskSettingsForm extends KioskStringValues {
  iotHubId?: string;
  name: string;
  mode: string;
  showInternalUserButton: 'yes' | 'no';
  internalUserButtonText: string;
  showExternalUserButton: 'yes' | 'no';
  externalUserButtonText: string;
  externalFlow: string;
  scannerMode: string;
  cameraEnabled: boolean;
  cameraDriver: string;
  cameraDirection: string;
  cameraRotation: string;
  lockerType: string;
  countryCode: string;
}

/** Values of a kiosk settings node's `subType`; always set by the API. */
export enum KioskNodeSubType {
  Manager = 'manager',
  Client = 'client'
}
